import _ from 'lodash'
import useValueExchangeLabel from '@/utils/useValueExchangeLabel'

export const query = {
  search_field: 'id', // 关键字类型
  keyword: '', // 关键字
  statuses: [], // 需求状态
  creation_types: [], //
  platform_types: [], // 平台
  channel_ids: [], // 渠道
  languages: [], // 语言
  categories: [], // 归属
  designer_ids: [], // 设计师
  demander_ids: [], // 提需师
  planner_ids: [], // 策划师
  account_manager_ids: [], // account manager
  developer_ids: [], // 研发
  adv_ids: [], // 广告主
  key_account: [], // 是否KA
  pays: [], // 是否支付
  time: [], // 时间，0 为起始时间，1 为结束时间
  search_time: 'submit_time',
  tag_ids: [],
  creation_size: [],
  is_makable: '',
  page: 1,
  page_size: 15,
  order: '',
  material_source: '', // 素材来源
  similar_demand_ids: [], // 参考需求
  biz_scenarios: [], // 业务场景
  bind_project_ids: '', // 关联项目 ID
}

/**
 * 数据交换
 * @param {Object} source 源对象。source 对象的属性值必须是 map 对象属性值（数组）的其中一个值或者值的数组
 * @param {Object} map 源对象对应的数据。属性值都是数组，数组的格式是 [{value: 1, label: 'label'}]，数组的的每一项的 value 值必须为 string 或 number
 * 例子：
 * source = { test: 1 }
 * map = { test: [ { value: 1, label: 'haha' }, { value: 2, label: 'haha2' } ] }
 */
export const exchange = (source, map) => {
  const target = {}

  _.each(source, (value, key) => {
    if (map[key]) {
      if (_.isArray(value)) {
        target[key] = value
          .map((item) => {
            return useValueExchangeLabel(item, map[key])
          })
          .filter((item) => !!item)
          .join()
      } else {
        target[key] = useValueExchangeLabel(value, map[key])
      }
    } else {
      target[key] = value
    }
  })

  return target
}
